/*
Usage Notes: 

The following web component can be dropped into any standard Shopify theme (i.e. non-headless), using Liquid to pass product data:

  <skio-plan-picker 
    product='{{ product | json | escape }}'
    selectedVariant='{{ product.selected_or_first_available_variant | json | escape }}'
    formId='{{ product_form_id }}'
    >
  </skio-plan-picker>
  <script src="{{ 'skio-plan-picker-component.js' | asset_url }}" type="module"></script>

  Note: formId not required if element is inside of a form already
*/

import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';
// LitJS Core https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js
// LitJS ALL (includes directives) https://cdn.jsdelivr.net/gh/lit/dist@2/all/lit-all.min.js

const skioStyles = css`
  .skio-plan-picker {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 1rem 0;
    border: 0;
    color: inherit;
    font-family: inherit;
  }

  .skio-onetime-second {
    order: 2;
  }
  
  .skio-group-container {
    display: none;
  }

  .skio-group-container--available {
    display: block;
    position: relative;
  }
  
  .skio-group-input {
    position: absolute;
    width: 0px;
    height: 0px;
    opacity: 0;
  }
  
  .skio-group-input:focus-visible ~ .skio-group-label {
    outline: 2px #ccc solid;
    outline-offset: 4px;
    border-radius: 5px;
  }
  
  .skio-group-label {
    display: flex;
    flex-direction: column;
    gap: 16px;
    cursor: pointer;
    position:relative;
    z-index:111;
  }
   
  .skio-group-topline {
    display: flex;
    align-items: center;
    width: 100%;
    font-size: 16px;

    font-family: var(--font-heading-family);
  }
  
  .skio-radio__container {
    display: flex;
    margin-right: 10px;
    color: #45a371;
  }
  
  .skio-radio {
    transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    transform-origin: center;
    transform: scale(0);
    opacity: 0;
  }

  .skio-group-label:hover .skio-radio {
    transform: scale(1);
    opacity: 0.75;
  }

  .skio-group-container--selected .skio-group-label .skio-radio {
    transform: scale(1);
    opacity: 1;
  }
  
  .skio-price-info {
    text-align: right;
    margin-left: auto;

    display: flex;
    flex-direction: column;
    font-size: 1.8rem;
    line-height: 1;
  }

  .servings {
    font-size: 14px;
    margin: 0.5rem 0 0 0;
  }

  .skio-price s {
    opacity: 50%;
    padding-right: 8px;
    text-decoration: line-through;
    font-size: 1.6rem;
  }
  
  .skio-group-title {
    text-transform: capitalize;
    letter-spacing: 0.05em;

    font-size: calc(var(--font-heading-scale) * 1.8rem);
    font-weight: var(--font-heading-weight);
  }
  
  .skio-save {
    color: #0fa573;
    border: 1px #0fa573 solid; 
    padding: 0px 8px;
    border-radius: 20px;
  }
  
  .skio-select-container {
    position: relative;
    width: auto;
    box-sizing: border-box;
  }

  .skio-select {
    display: flex;
    align-items: center;
    width: 100%;
    white-space: nowrap;
    background-image: url("data:image/svg+xml, %3Csvg%20width=%2216%22%20height=%2216%22%20viewBox=%220%200%2016%2016%22%20fill=%22none%22%20xmlns=%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d=%22M13%206L8%2011L3%206%22%20stroke=%22currentColor%22%20stroke-width=%222%22%20stroke-linecap=%22round%22%20stroke-linejoin=%22round%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fsvg%3E");
    background-position: right 16px top 50%;
    background-size: 16px;
    background-repeat: no-repeat;

    border: 1px solid rgba(var(--color-button), var(--alpha-button-background));
    background-color: #ffffff;
    width: 100%;

    border-radius: 12px;
    cursor: pointer;
    padding: 12px 16px;
    z-index: 2;

    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    font-weight: 500;
    position: relative;

    color: inherit;
    font-family: inherit;
  }

  .select-options { 
    position: absolute;
    top: -10px;
    border: 1px solid rgba(var(--color-button), var(--alpha-button-background));
    border-radius: 0 0 12px 12px;
    top: 20px;
    background: white;
    width: 100%;
    z-index: 1;
    box-sizing: border-box;
    padding: 40px 16px 12px;

    font-size: 16px;

    display: none;
  }

  .select-options.open {
    display: block;
  }

  .select-option.selected {
    color: rgba(var(--color-button), var(--alpha-button-background));
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  .skio-group-title, .skio-price-info, .skio-select-container {
    opacity: 0.3;
    transition: opacity 0.25s cubic-bezier(0.4,0,0.2,1);
  }

  .skio-group-title:hover{
    opacity:1;
  }

  .skio-group-container--selected .skio-group-title, .skio-group-container--selected .skio-price-info, .skio-group-container--selected .skio-select-container {
    opacity: 1;
  }

  .info-popup-container {
    display: none;
    position: relative;
    vertical-align: middle;
  }

  .info-popup-container .info-popup {
    position: absolute;
    width: max-content;
    z-index: 4;
    background: #081d33 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 6px;
    color: #fff;
    padding: 2rem 2rem 2rem 4rem;
    font-size: 1.6rem;
    right: -2.2rem;
    opacity: 0;
    visibility: hidden;
  }

  .info-popup:before {
    content: '';
    width: 0;
    height: 0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-top: 18px solid #081d33;
    position: absolute;
    margin-left: 0;
    margin: 0 !important;
    right: 2rem;
    transform: rotate(180deg);
    top: -1.8rem;
  }

  .info-popup-container:hover .info-popup {
    opacity: 1;
    visibility: visible;
  }

  @media(min-width: 750px) {
    .info-popup-container {
      display: inline-block;
    }
  }
`;

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    product: { type: Object },            //required
    productHandle: { type: String },      //optional (unless product isn't passed, then required)
    key: { type: String },                //optional, defaults to product.id; identifier for this instance of the Skio plan picker

    formId: { type: String },

    subscriptionFirst: { type: Boolean }, //optional, defaults to false; if true, shows subscription option above onetime
    startSubscription: { type: Boolean }, //optional, defaults to false; if true, auto-selects subscription on page load
    hideSelect: { type: Boolean }, // optional, defaults to false; if true, hides the select dropdown
    discountFormat: { type: String },     //optional, defaults to percent; can also pass "fixed"
    
    currency: { type: String },           //optional, defaults to 'USD', but can pass any 3 char identifier
    language: { type: String },           //optional, defaults to 'en-US', but can pass any similarly formatted language identifier
    moneyFormatter: {},                   //placeholder for object
  
    selectedVariant: { type: Object },    //placeholder for data
    skioSellingPlanGroups: {},            //placeholder for data
    availableSellingPlanGroups: {},       //placeholder for data
    selectedSellingPlanGroup: {},         //placeholder for data
    selectedSellingPlan: {},              //placeholder for data

    _selectOpened: { type: Boolean },
  };

  static styles = skioStyles;

  constructor() {
    super();
    
    this.product = null;
    this.selectedVariant = null;

    this.productHandle = null;

    this.formId = null;

    this.form = null;

    this.key = null;

    this.skioSellingPlanGroups = null;
    this.availableSellingPlanGroups = null;

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;

    this.startSubscription = false;
    this.subscriptionFirst = false;
    this.hideSelect = false;

    this.skioMainProduct = true;

    this.discountFormat = 'percent';

    this.currency = 'USD';
    this.language = 'en-US';
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: this.currency,
    });

    this._selectOpened = false;
  }

  connectedCallback() {
    super.connectedCallback();

    if(!this.product && this.productHandle) {
      this.fetchProduct(this.productHandle);
    }

    this.bindFormEvents();
  }

  render() {
    if(!this.product || !this.selectedVariant) return;
    
    return html`
      <fieldset class="skio-plan-picker" skio-plan-picker="${ this.key }">
        <div class="skio-group-container ${ this.product.requires_selling_plan == false ? 'skio-group-container--available' : '' } ${ this.selectedSellingPlanGroup == null ? 'skio-group-container--selected' : '' } ${ this.subscriptionFirst ? 'skio-onetime-second' : ''}" skio-group-container 
          @click=${() => this.selectSellingPlanGroup(null) } >
        
          <input id="skio-one-time-${ this.key }" class="skio-group-input" name="skio-group-${ this.key }" type="radio" value="" 
            skio-one-time ?checked=${ this.startSubscription == false && this.product.requires_selling_plan == false ? true : false }>
          <label class="skio-group-label" for="skio-one-time-${ this.key }">
            <div class="skio-group-topline">
              <div class="skio-radio__container">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1"></circle>
                  <circle class="skio-radio" cx="12" cy="12" r="9" fill="white"></circle>
                  <circle class="skio-radio" cx="12" cy="12" r="6" fill="currentColor"></circle>
                </svg>
              </div>

              <div class="skio-group-title">
                One-Time Purchase
              </div>

              <div class="skio-price-info">
                <div class="skio-price">
                  ${ this.selectedVariant.compareAtPrice && this.selectedVariant.compareAtPrice > this.selectedVariant.price ? html`
                    <s skio-compare-price>${ this.moneyFormatter.format(this.selectedVariant.compareAtPrice / 100) }</s>
                  `: ''}
                  <span skio-onetime-price>${ this.moneyFormatter.format(this.selectedVariant.price / 100) }</span>
                </div>

                <p class="servings">${ this.servingPrice(this.selectedVariant.price) }</p>
              </div>
            </div>
          </label>
        </div>
        ${ this.availableSellingPlanGroups ? this.availableSellingPlanGroups.map((group, index) => 
          html`
            <div class="skio-group-container skio-group-container--available ${ this.selectedSellingPlanGroup == group ? 'skio-group-container--selected' : '' }" skio-group-container
              @click=${() => this.selectSellingPlanGroup(group) }>
              <input id="skio-selling-plan-group-${ index }-${ this.key }" class="skio-group-input" name="skio-group-${ this.key }"
                type="radio" value="${ group.id }" skio-selling-plan-group="${ group.id }" ?checked=${ this.selectedSellingPlanGroup == group ? true : false } >
              <label class="skio-group-label" for="skio-selling-plan-group-${ index }-${ this.key }">
                <div class="skio-group-topline">
                  <div class="skio-radio__container">
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1"></circle>
                      <circle class="skio-radio" cx="12" cy="12" r="9" fill="white"></circle>
                      <circle class="skio-radio" cx="12" cy="12" r="6" fill="currentColor"></circle>
                    </svg>
                  </div>

                  <div class="skio-group-title">
                    ${ group.name == 'Subscription' ? 'Subscribe' : group.name }
                    ${ this.discount(group.selected_selling_plan).percent !== '0%' ? html`
                      & Save <span skio-discount>${ this.discountFormat == 'percent' ? this.discount(group.selected_selling_plan).percent : this.discount(group.selected_selling_plan).amount }</span>
                    ` : html`` }

                    <span class="info-popup-container">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px" fill="currentColor">
                        <path d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 9 L 13 9 L 13 7 L 11 7 z M 11 11 L 11 17 L 13 17 L 13 11 L 11 11 z"/>
                      </svg>

                      <ul class="info-popup">
                        <li> *subscriptions require 3 shipment minimum</li>
                        <li>15% off Your Subscription</li>
                        <li>Free US Shipping on 2+ Bottles</li>
                        <li>Members-only swag</li>
                        <li>Free Samples & Gifts</li>
                        <li>Early Access to New Products</li>
                        <li>Free Drinks & Discounts</li>
                      </ul>
                    </span>
                  </div>

                  <div class="skio-price-info">
                    <div class="skio-price">
                      ${ this.selectedVariant.price > this.price(group.selected_selling_plan, false) ? html`
                        <s skio-compare-price>${ this.moneyFormatter.format(this.selectedVariant.price / 100) }</s>
                      `: ''}

                      <span skio-subscription-price>${ this.price(group.selected_selling_plan) }</span>
                    </div>

                    <p class="servings">${ this.servingPrice(this.price(group.selected_selling_plan, false)) } </p>
                  </div>
                </div>

                <div class="skio-select-container">
                  ${ !this.hideSelect ? html`
                    <button class="skio-select" @click=${ (e) => this._selectOpened = !this._selectOpened }>
                      ${ group.name == 'Subscription' ? `Delivery ${ group.selected_selling_plan.name.toLowerCase() }` : `${ group.selected_selling_plan.name }` }
                    </button>

                    <div class="select-options ${ this.selectedSellingPlanGroup == group && this._selectOpened ? 'open' : ''}">
                      ${ group ? group.selling_plans.map((selling_plan) =>
                        html`
                          <div tabindex="0" @keydown=${(e) => e.key === 'Enter' ? this.selectSellingPlan(selling_plan, group) : null} @click=${(e) => this.selectSellingPlan(selling_plan, group)} class="select-option ${ this.selectedSellingPlan == selling_plan ? 'selected' : ''}">
                            ${ group.name == 'Subscription' ? `Delivery ${ selling_plan.name.toLowerCase() }` : `${ selling_plan.name }` }
                          </div>
                        `) : ''}
                    </div>
                  ` : '' }
                </div>
              </label>
            </div>
          `
        ): ''}
      </fieldset>`
  }

  servingPrice = (price) => {
    const servingOption = this.selectedVariant.options.find(option => option.toLowerCase().includes('servings'))
    const servings = servingOption ? Number(servingOption.match(/\d+/)[0]) : 1;
    return this.moneyFormatter.format(price / servings / 100) + ' /Serving';
  }

  bindFormEvents() {
    this.form =
      document.querySelector(`#${this.formId}`) ||
      this.closest('form[action="/cart/add"]')
    if (!this.form) {
      return
    }

    this.variantInput = this.form.querySelector('[name="id"]')

    if (this.variantInput) {
      this.variantInput.addEventListener('change', (e) => {
        this.selectedVariant = this.product.variants.find((variant) => variant.id == e.target.value)
      })
    }
  }

  updated = (changed) => {
    if(changed.has('product') && this.product) {
      //update key
      this.key = this.key ? this.key : this.product.id;

      //update skioSellingPlanGroups
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        selling_plan_group => selling_plan_group.app_id === 'SKIO'
      )
    }

    if(changed.has('selectedVariant') && this.selectedVariant) {
      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      this.availableSellingPlanGroups = this.skioSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations.some(
            selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
          )
        )
      )

      //update selectedSellingPlan value
      if (this.availableSellingPlanGroups?.length > 0) {
        //update each group with a default selected_selling_plan
        this.availableSellingPlanGroups.forEach((group => {
          group.selected_selling_plan = group.selling_plans[0];
        }));

        if (this.startSubscription == true || this.product.requires_selling_plan == true) {
          this.selectedSellingPlanGroup = this.availableSellingPlanGroups[0];
          this.selectedSellingPlan = this.availableSellingPlanGroups[0].selling_plans[0];
        } else {
          this.selectedSellingPlan = null;
          this.selectedSellingPlanGroup = null
        }
      } else {
        this.selectedSellingPlan = null;
        this.selectedSellingPlanGroup = null
      }

      this.updateForm();
    }

    if(changed.has('selectedSellingPlan')) {
      //update price of price elements if applicable
      document.querySelectorAll(`[skio-price][skio-key="${ this.key }"]`).forEach((el) => {
        el.innerHTML = this.price(this.selectedSellingPlan);
      });

      //update display of external content elements
      document.querySelectorAll(`[skio-onetime-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan !== null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      document.querySelectorAll(`[skio-subscription-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan == null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
      const event = new CustomEvent(`skio::update-selling-plan`, {
        bubbles: true, 
        composed: true, 
        detail: {
          variant: this.selectedVariant,
          sellingPlan: this.selectedSellingPlan,
          key: this.key
        }
      });

      this.dispatchEvent(event);

      this.updateForm();
    }
  }

  log = (...args) => {
    args.unshift('%c[skio]', 'color: #8770f2;');
    console.log.apply(console, args);
  }

  error = (...args) =>  {
    args.unshift('%c [skio]', 'color: #ff0000');
    console.error.apply(console, args);
  }
  
  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan;

    //update the form that was passed, if any
    this.updateForm();
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(selling_plan, group) {
    if (selling_plan && group) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;

      this._selectOpened = false;
    }
    else this.log("Error: couldn't find selling plan with id " + element.value + " for variant " + this.selectedVariant.id + " from product " + this.product.id + " : " + this.product.handle);
  }

  // Formats integer value into money value
  money(price) {
    return this.moneyFormatter.format(price / 100.0)
  }

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount(selling_plan) {
    if (!selling_plan)
      return { percent: '0%', amount: 0 }
    
    const price_adjustment = selling_plan.price_adjustments[0]
    const discount = { percent: '0%', amount: 0 }
    const price = this.selectedVariant.price;
    
    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = `${price_adjustment.value}%`
        discount.amount = Math.round(
          (price * price_adjustment.value) / 100.0
        )
        break
      case 'fixed_amount':
        discount.percent = `${Math.round(
          ((price_adjustment.value * 1.0) / price) * 100.0
        )}%`
        discount.amount = price_adjustment.value
        break
      case 'price':
        discount.percent = `${Math.round(
          (((price - price_adjustment.value) * 1.0) /
            price) *
            100.0
        )}%`
        discount.amount = price - price_adjustment.value
        break
    }
    
    return discount
  }

  // Calculates the variant's price for the given selling plan, returns a formatted money value (if desired)
  price(selling_plan, formatted = true) {
    return formatted
      ? this.money( this.selectedVariant.price - this.discount(selling_plan).amount)
      :  this.selectedVariant.price - this.discount(selling_plan).amount
  }

  // Updates element data to be registered by forms
  updateForm() {
    let $sellingPlan = this.querySelector('input[name=selling_plan]');
    if($sellingPlan) this.querySelector('input[name=selling_plan]').value = this.selectedSellingPlan ? this.selectedSellingPlan.id : '';
  }

  // Optional functions keep if necessary 

  /**
   *   
   * 
   */
  
  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        ...(this.selectedSellingPlan && { selling_plan: this.selectedSellingPlan?.id })
      }
    ];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
    .then((response) => response.json())
    .then((response) => {
      this.log("SKIO added item to cart: ", response);
      //dispatch CustomEvent to tell document that an item was added to cart
      const event = new CustomEvent(`skio::added-to-cart`, {
        bubbles: true, 
        composed: true, 
        detail: {
          response,
          key: this.key
        }
      });

      this.dispatchEvent(event);
    })
    .catch((error) => {
      this.error(`SKIO ${ this.key } error adding item to cart: `, error);
    });
  } 

  fetchProduct = (handle) => {
    return fetch(`/products/${ handle }.js`)
    .then((response) => response.json())
    .then((product) => {
      this.product = product;
      this.selectedVariant = product.variants[0];

      return product;
    });
  }
}

customElements.define('skio-plan-picker', SkioPlanPickerComponent);